/**
 * Module to add fade effect to the right edge of data table.
 * @author Yi Liu (yliu@yext.com)
 */
goog.provide('yext.ui.tablefade');

/**
 * Initialize the fade effect on data tables
 */
yext.ui.tablefade.init = function() {
  $('.data-table-fade-area').each(function() {
    new yext.ui.tablefade.Fade($(this));
  });

  $('.data-table-fade-area').on('contentUpdated', '#data-table,.js-data-table', function(e) {
    var $container = $(e.target).closest('.data-table-container');
    if ($container.length) {
      new yext.ui.tablefade.Fade($container);
    }
  });
};

/**
 * @param {!jQuery} $container The container element of the datatable
 * @constructor
 */
yext.ui.tablefade.Fade = function($container) {
  this.$container = $container;
  this.$dataTable = $container.find('#data-table');

  this.toggleFade();
  this.bindScroll();
  this.bindWindowResize();
};

/**
 * Bind the scroll event on the div container
 */
yext.ui.tablefade.Fade.prototype.bindScroll = function() {
  var self = this;
  this.$container.scroll(function() {
    var $this = $(this);
    // Note (yliu): Round down the number to handle the case where the page zoomed.
    if (Math.floor($this.scrollLeft()) == self.rightEnd) {
      self.$rightFade.stop(true, true).fadeOut(100);
    } else {
      self.$rightFade.stop(true, true).fadeIn(100);
    }
  });
};

/**
 * Bind the window resize event to see if we should show or hide the right fade
 */
yext.ui.tablefade.Fade.prototype.bindWindowResize = function() {
  var self = this;
  $(window).resize(function() {
    self.toggleFade();
  });
};

/**
 * Check if to show or hide the right fade
 */
yext.ui.tablefade.Fade.prototype.toggleFade = function() {
  var scrollWidth = this.$container[0].scrollWidth;
  var clientWidth = this.$container[0].clientWidth;
  var tableHeadHeight = this.$container.find('> table > thead').height();

  this.$rightFade = $('<div class="right-fade"></div>').css({top: tableHeadHeight + 'px'});

  this.rightEnd = scrollWidth - clientWidth;

  if (scrollWidth > clientWidth) {
    $('.right-fade').remove();
    this.$container.append(this.$rightFade);
  } else {
    $('.right-fade').remove();
  }
};
